import { z } from "zod"

import { parseHexaColor } from "~/utils/parse-hexa-color"

export const hexaColorSchema = z
  .string()
  .nullish()
  .transform((val) => parseHexaColor(val) ?? undefined)
